var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.008 96.016C74.5221 96.016 96.016 74.5221 96.016 48.008C96.016 21.4939 74.5221 0 48.008 0C21.4939 0 0 21.4939 0 48.008C0 74.5221 21.4939 96.016 48.008 96.016Z",
    fill: "#FFF2DE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4669 27.5636C27.2848 27.5636 27.131 27.7174 27.131 27.8995V68.5648C27.131 68.7469 27.2848 68.9007 27.4669 68.9007H68.1481C68.3377 68.9007 68.4841 68.7396 68.4841 68.5808V27.8995C68.4841 27.7174 68.3303 27.5636 68.1481 27.5636H27.4669ZM25.5312 27.8995C25.5312 26.8339 26.4013 25.9639 27.4669 25.9639H68.1481C69.2138 25.9639 70.0838 26.8339 70.0838 27.8995V68.5808C70.0838 69.6378 69.2064 70.5005 68.1481 70.5005H27.4669C26.4013 70.5005 25.5312 69.6304 25.5312 68.5648V27.8995Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4435 21.8525V31.6589H34.8438V21.8525H36.4435Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7755 21.8525V31.6589H59.1758V21.8525H60.7755Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6673 39.9298H26.7305V38.3301H69.6673V39.9298Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2849 50.1041H26.332V48.5044H69.2849V50.1041Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2849 60.2623H26.332V58.6626H69.2849V60.2623Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8654 38.4741V68.981H36.2656V38.4741H37.8654Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5997 38.4741V68.981H47V38.4741H48.5997Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3341 38.4741V68.981H57.7344V38.4741H59.3341Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.19 44.7931H27.1953V43.1934H59.19V44.7931Z",
    fill: "#0067CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5902 65.4293H27.1953V63.8296H57.5902V65.4293Z",
    fill: "#0067CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7841 55.1427L36.793 55.0812L36.7965 53.543L68.7876 53.6045L68.7841 55.1427Z",
    fill: "#0067CE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.7889,
    cy: 63.1893,
    rx: 10.3983,
    ry: 10.3983,
    fill: "#FFF2DE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.931 61.3764L64.1318 67.69L60.2422 64.0545L61.3345 62.8858L64.1353 65.5036L69.8425 60.2041L70.931 61.3764Z",
    fill: "#0067CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7889 71.9878C69.6482 71.9878 73.5874 68.0486 73.5874 63.1893C73.5874 58.33 69.6482 54.3907 64.7889 54.3907C59.9296 54.3907 55.9904 58.33 55.9904 63.1893C55.9904 68.0486 59.9296 71.9878 64.7889 71.9878ZM64.7889 73.5876C70.5317 73.5876 75.1872 68.9321 75.1872 63.1893C75.1872 57.4465 70.5317 52.791 64.7889 52.791C59.0461 52.791 54.3906 57.4465 54.3906 63.1893C54.3906 68.9321 59.0461 73.5876 64.7889 73.5876Z",
    fill: "#0067CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSuccess);
export default __webpack_public_path__ + "static/media/calendar-success.2826407474cfba73cf498ee1eebd5212.svg";
export { ForwardRef as ReactComponent };